/*
  localStorageJSON.js
*/

// Lib.
import isLocalStorageSupported from './isLocalStorageSupported';

/**
 * Wrapper around localStorage that parses/stringifies JSON.
 * If null is provided, the key is cleared.
 */
class localStorageJSON {

  constructor() {
    this._supported = isLocalStorageSupported();
  }

  getItem(key) {
    if (this._supported && typeof key === 'string') {
      const value = localStorage.getItem(key);
      if (value != null) {
        try {
          return JSON.parse(value);
        } catch (err) {
          // Ignore error.
        }
      }
    }
    return null;
  }

  setItem(key, value) {
    if (this._supported && typeof key === 'string') {
      try {
        if (value != null) {
          localStorage.setItem(key, JSON.stringify(value));
        } else {
          localStorage.removeItem(key);
        }
      } catch (err) {
        // Ignore error.
      }
    }
  }

  removeItem(key) {
    if (this._supported && typeof key === 'string') {
      try {
        localStorage.removeItem(key);
      } catch (err) {
        // Ignore error.
      }
    }
  }

}

export default new localStorageJSON();
